import { useEffect, useState } from 'react';
import axios from 'axios';
import { Bell } from 'lucide-react';
import { toast } from 'sonner';
import { Switch } from './ui/switch';
import { useFlag } from '../context/FeatureFlagsContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/users/me/referral-email`;

function useReferralEmailPref() {
  const [enabled, setEnabled] = useState(null);
  useEffect(() => {
    axios.get(API, { withCredentials: true }).then(({ data }) => setEnabled(data.enabled)).catch(() => setEnabled(true));
  }, []);
  const toggle = async (next) => {
    setEnabled(next);
    try {
      await axios.put(API, { enabled: next }, { withCredentials: true });
      toast.success(next ? 'Monthly scoreboard email on.' : 'Monthly scoreboard email off.');
    } catch {
      setEnabled(!next);
      toast.error('Could not save. Try again.');
    }
  };
  return { enabled, toggle };
}

export const ReferralEmailPanel = ({ modern = false }) => {
  const visible = useFlag('email.customer.referral_scoreboard', false);
  const { enabled, toggle } = useReferralEmailPref();
  if (!visible || enabled === null) return null;
  const row = (
    <div className="flex items-center justify-between gap-4">
      <div>
        <p className={modern ? 'text-sm font-medium' : 'font-mono text-sm text-[#39FF14]'} style={modern ? { color: 'var(--am-ink-1)' } : {}}>
          Monthly referral scoreboard
        </p>
        <p className={modern ? 'text-xs mt-0.5' : 'font-mono text-xs text-[#4B6B52] mt-0.5'} style={modern ? { color: 'var(--am-ink-3)' } : {}}>
          An email on the 15th with your friends' progress and your tier track.
        </p>
      </div>
      <Switch
        checked={enabled}
        onCheckedChange={toggle}
        data-testid="referral-email-toggle"
        className={modern ? '' : 'data-[state=unchecked]:bg-[#2A3A2E] border border-[#4B6B52] data-[state=checked]:bg-[#39FF14]'}
      />
    </div>
  );
  if (modern) {
    return (
      <section className="am-card p-5 sm:p-6" data-testid="notifications-panel">
        <h2 className="am-section-title flex items-center gap-2 mb-4">
          <Bell className="w-4 h-4" style={{ color: 'var(--am-emerald-600)' }} />Notifications
        </h2>
        {row}
      </section>
    );
  }
  return (
    <div className="mt-6 pt-6 border-t border-[#2A0F3D]" data-testid="notifications-panel">
      <h3 className="text-[#6B8E73] font-mono text-xs uppercase tracking-wider mb-4 flex items-center gap-2">
        <Bell className="w-3.5 h-3.5" /><span>NOTIFICATIONS</span>
      </h3>
      {row}
    </div>
  );
};
